import React, { createContext, useState } from "react";
import { ContextProviderProps } from "../../../types";
import {
  CentralRegistryState,
  UpdateCentralRegistryFunction,
} from "./centralRegistry.types";

export const initialState = (): CentralRegistryState => {
  return {
    //Response for registarOMarkamaDuvanskihProizvoda

    brandRegistryTable: [],
    filtersRegistryVrstaDuvanskih: [],
    filtersRegistryPakovanje: [],
    filtersRegistryTipObveznika: [],

    //Response for registarMaloprodajnihCena

    retailTable: [],

    //Response for evidencionaListaPosebanPostupak

    brandRegistrationTable: [],

    //Response for evidencionaListaMaloprodajnihObjekata

    merchantRegistrationTable: [],

    //Response for privredniSubjektiPosebanPostupak
    //Response for registarTrgovacaNaVeliko
    //Response for registarProizvodjaca
    //Response for registarUvoznika

    dynamicTable: [],
  };
};

interface CentralRegistryContextValue {
  centralRegistry: CentralRegistryState;
  setCentralRegistry: UpdateCentralRegistryFunction;
  clearCentralRegistryState: () => void;
}

export const CentralRegistryContext = createContext<CentralRegistryContextValue>(
  null as any
);

export const CentralRegistryContextProvider = ({
  children,
}: ContextProviderProps) => {
  const [centralRegistry, setCentralRegistryState] = useState(initialState());

  const handleSetCentralRegistry = (
    updatedState: Partial<CentralRegistryState>
  ) => {
    setCentralRegistryState((prev) => ({ ...prev, ...updatedState }));
  };

  const setCentralRegistry = (updatedState: Partial<CentralRegistryState>) => {
    handleSetCentralRegistry({ ...updatedState });
  };

  const clearCentralRegistryState = () => {
    setCentralRegistryState(initialState());
  };

  return (
    <CentralRegistryContext.Provider
      value={{
        centralRegistry,
        setCentralRegistry,
        clearCentralRegistryState,
      }}
    >
      {children}
    </CentralRegistryContext.Provider>
  );
};
